<template>
  <!-- 已报名人员 -->
  <div>
    <div class="already-enroll">
      <div id="anchorTagTwo" class="h">会议报名</div>
      <div class="table" ref="table">
        <table cellspacing="1">
          <tr v-for="(item, index) in personnelList" :key="item.id">
            <td class="number">{{ index + 1 }}</td>
            <td class="author">{{ item.name }}</td>
            <td class="company">{{ item.unit }}</td>
            <td class="state">{{ item.status | registrationStatus }}</td>
            <!-- <td class="operate" @click="ModifyTheForm(item)">修改</td> -->
          </tr>
        </table>
      </div>
      <div class="page-box" v-if="total > 10">
        <Icon class="icon" size="18" type="ios-arrow-back" @click="back" />
        <Icon
          class="icon"
          size="18"
          type="ios-arrow-forward"
          @click="forward"
        />
      </div>
      <span
        v-if="personnelList.length !== 0"
        class="add"
        @click="$emit('AddPersonnel')"
      >
        添加其他参会人员
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "RegisteredPersonnel",
  props: {},
  data() {
    return {
      personnelList: [], //参会人员
      pageNo: 1,
      total: 0,
    };
  },
  // 控制会议报名状态
  filters: {
    // 报名状态
    registrationStatus(num) {
      if (num === 1) return "已报名";
      if (num === 2) return "已取消";
    },
  },
  computed: {
    ...mapState(["hasLogin"]),
    // 作者
    compellation() {
      return (item) => {
        return item.filter((it) => {
          if (it.code === "name") {
            return it;
          }
        });
      };
    },
    // 工作单位
    organization() {
      return (item) => {
        return item.filter((it) => {
          if (it.code === "unit") {
            return it;
          }
        });
      };
    },
  },
  watch: {},
  created() {
    if (this.hasLogin) {
      this.getSignUpList();
    } else {
      this.$emit("ModifyTheForm");
    }
  },
  methods: {
    back() {
      if (this.pageNo === 1) return;
      this.pageNo = --this.pageNo;
      this.getSignUpList();
    },
    forward() {
      if (this.pageNo > this.total / 10) return;
      this.pageNo = ++this.pageNo;
      this.getSignUpList();
    },
    // 获取参会人员列表
    async getSignUpList() {
      let obj = {
        meetingId: this.$route.query.id,
        pageNo: this.pageNo,
        pageSize: 10,
      };
      const res = await this.$apis.userServe.getMySignUpList(obj);
      this.total = +res.data.total;
      if (this.total > 0) {
        this.personnelList = res.data.list.map((item) => {
          let nameArr = item.signUpDtos.filter((i) => i.code === "name");
          // let unitArr = item.signUpDtos.filter(i => i.code === 'unit')
          let unitArr = item.signUpDtos.filter((i) => i.code === "phone");
          return {
            status: item.status,
            name: nameArr[0].content,
            unit: unitArr[0].content,
          };
        });
      } else {
        this.$emit("ModifyTheForm");
      }
    },
    // 修改
    // ModifyTheForm(item) {
    //   this.$emit("ModifyTheForm", item);
    // },
  },
};
</script>

<style scoped lang="scss">
.already-enroll {
  position: relative;
  .h {
    font-size: 16px;
    color: #0344a1;
    font-weight: bold;
    margin-bottom: 25px;
  }
  .table {
    width: 100%;
    background: #e5e5e5;
    table {
      width: 100;
      text-align: center;
      td {
        height: 45px;
        background: #f4f8ff;
        color: #000;
        font-size: 14px;
        // margin-top: -1px;
      }
      .number {
        width: 50px;
        font-size: 14px;
      }
      .author {
        width: 100px;
      }
      .company {
        width: 484px; // 有修改则484px,无修改则384px
        height: 45px;
        line-height: 45px;
        padding: 0 20px;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .state {
        width: 100px;
      }
      .operate {
        width: 100px;
        color: #0b4aa4;
        cursor: pointer;
      }
    }
  }
  .page-box {
    margin-top: 10px;
    text-align: center;
    .icon {
      margin: 0 5px;
      cursor: pointer;
    }
  }
  .add {
    display: inline-block;
    color: #2245be;
    cursor: pointer;
    margin-top: 10px;
    margin-left: 10px;
  }
}
</style>
